import React from 'react'
import SideContent from 'components/SideContent'
import SideInfoHistory from 'components/SideInfoHistory'
import SideInfoHelp from 'components/SideInfoHelp'
import SideInfoApps from 'components/SideInfoApps'
import SideInfoPromo from 'components/SideInfoPromo'

function Side() {
  return (
    <SideContent>
      <SideInfoHistory />
      <SideInfoHelp />
      <SideInfoPromo />
      <SideInfoApps />
    </SideContent>
  )
}

export default Side
